import React from 'react'
import {withRouter} from "react-router";
import moment from "moment";
import ellipsisContent from "../../utils/EllipsisContent";
import globalStyle from "../../styles/globalStyle";
import ellipsis from "../../styles/ellipsis.module.css";
import PaginationList from "../../common/Paginator/PaginationList";
import InterestSearchTag from "../../common/InterestSearchTag/InterestSearchTag";
import HotRank from "../../common/HotRank/HotRank";
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";

const InterestSearch = (props) => {
    const { match, history } = props;

    const { interestId, title } = match.params;

    return (
        <div style={{width: 1200, display: 'flex'}}>
            <PaginationList
                title={title}
                style={{minHeight:780}}
                url={`/api/SearchTag?id=${interestId}`}
                requestOption={{headers: {Accept: 'application/json,version=2'}}}
                renderItem={(item) => {
                    const {id, title, cover_link, change_time, content = '', tab} = item;
                    return(
                        <div
                            key={id}
                            style={{display: 'flex', padding: 16}}
                            onClick={() => {
                                history.push({ pathname: `/${newsDetailPushTarget(tab)}/${id}`});
                            }}
                        >
                            <img src={cover_link} style={{width: 180, height: 120}}/>
                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: 16, width: 692}}>
                                <div style={{...globalStyle.flexSpaceBetweenRow,marginBottom: 16}}>
                                    <span style={{fontSize: 18, fontWeight: 400, color: '#333333'}}>{title}</span>
                                    <span>{moment(change_time).format('YYYY-MM-DD')}</span>
                                </div>
                                <span className={ellipsis.ellipsis} style={{lineHeight: '25px', height: 50}}>
                                    {ellipsisContent(content)}
                                </span>
                            </div>
                        </div>
                    );
                }}
            />
            <div style={{marginLeft: 16}}>
                <InterestSearchTag/>
                <div style={{height: 16}}/>
                <HotRank/>
            </div>
        </div>
    );
};

export default withRouter(InterestSearch)
